<div class="pt-2 form-element">
  @if (props?.label || props?.tooltip) {
    <label [style]="{ 'justify-content': props?.label ? 'space-between' : 'flex-end' }">
      @if (props?.label) {
        <span>{{ props?.label }}</span>
      }
      <ng-content select=".tooltip-content"></ng-content>
    </label>
  }

  <div class="p-inputgroup">
    <p-inputMask
      [formControl]="formControl"
      [mask]="mask"
      [disabled]="!props.is_editable"
      [placeholder]="inputFormat"
      [slotChar]="inputFormat">
    </p-inputMask>
  </div>

  @if (formControl) {
    <cap-validator [control]="formControl" [customName]="props?.label"></cap-validator>
  }
</div>
